import { useCallback } from "react"
import { useMutation } from "react-relay"
import { graphql } from "relay-runtime"
import {
  SetAdditionalCapacityInput,
  useUpdateCapacityMutation as UpdateCapacityMutation,
} from "@/modules/productivity-cockpit/services/__generated__/useUpdateCapacityMutation.graphql"

const mutation = graphql`
  mutation useUpdateCapacityMutation($input: SetAdditionalCapacityInput!) {
    setAdditionalCapacity(input: $input) {
      poolCapacityValuesOutput {
        ...CapacityPlanFragment @relay(mask: false)
      }
    }
  }
`

export const useUpdateCapacityMutation = () => {
  const [commit] = useMutation<UpdateCapacityMutation>(mutation)

  return useCallback(
    (input: SetAdditionalCapacityInput, onCompleted?: () => void) => {
      commit({
        variables: {
          input,
        },
        onCompleted,
      })
    },
    [commit],
  )
}
